import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarUserButtonComponent } from './toolbar-user-button/toolbar-user-button.component';
import { ToolbarNotificationsComponent } from './toolbar-notifications/toolbar-notifications.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { ToolbarAlphaComponent } from './toolbar-alpha/toolbar-alpha.component';
import { ToolbarBetaComponent } from './toolbar-beta/toolbar-beta.component';
import { SearchComponent } from './search/search.component';
import { ToolbarGammaComponent } from './toolbar-gamma/toolbar-gamma.component';
import { ToolbarNavigationComponent } from './toolbar-navigation/toolbar-navigation.component';
import { ToolbarNavigationItemComponent } from './toolbar-navigation/toolbar-navigation-item/toolbar-navigation-item.component';
import { ToolbarNavigationDropdownItemComponent } from './toolbar-navigation/toolbar-navigation-item/toolbar-navigation-dropdown-item/toolbar-navigation-dropdown-item.component';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UtilsModule } from '../utils/utils.module';
import {MatDialogModule, MatTooltipModule} from '@angular/material';
import {UserDataDialogComponent} from '../../pages/users/user-data-dialog/user-data-dialog.component';
import {UserDataDialogModule} from '../../pages/users/user-data-dialog/user-data-dialog.module';
import {UsersModule} from '../../pages/users/users.module';
import {DiscordPopupComponent} from '../../pages/users/discord-popup/discord-popup.component';
import {DiscordPopupModule} from '../../pages/users/discord-popup/discord-popup.module';
import {AngularCountdownTimerModule} from 'angular8-countdown-timer';
import {RaceDetailModalComponent} from '../../pages/events/race-detail-modal/race-detail-modal.component';
import {NameChangeReqComponent} from '../../pages/users/name-change-req/name-change-req.component';
import {NameChangeReqModule} from '../../pages/users/name-change-req/name-change-req.module';
import {ReportSelfAcceptanceComponent} from '../../pages/users/report-self-acceptance/report-self-acceptance.component';
import {ReportSelfAcceptanceModule} from '../../pages/users/report-self-acceptance/report-self-acceptance.module';
import { ConnectorpopupComponent } from './toolbar-notifications/connectorpopup/connectorpopup.component';
import {AdServiceModule} from '../../pages/ad-service/ad-service.module';
import {LoginwindowComponent} from '../../pages/loginwindow/loginwindow.component';
import {LoginwindowModule} from '../../pages/loginwindow/loginwindow.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    ScrollbarModule,
    MatInputModule,
    MatMenuModule,
    UtilsModule,
    MatRippleModule,
    MatTooltipModule,
    UserDataDialogModule,
    DiscordPopupModule,
    AngularCountdownTimerModule,
    NameChangeReqModule,
    ReportSelfAcceptanceModule,
    MatDialogModule,
    AdServiceModule,
    LoginwindowModule
  ],
  declarations: [
    ToolbarUserButtonComponent,
    ToolbarNotificationsComponent,
    SearchBarComponent,
    ToolbarAlphaComponent,
    ToolbarBetaComponent,
    SearchComponent,
    ToolbarGammaComponent,
    ToolbarNavigationComponent,
    ToolbarNavigationItemComponent,
    ToolbarNavigationDropdownItemComponent,
    ConnectorpopupComponent
  ],
  exports: [
    ToolbarUserButtonComponent,
    ToolbarNotificationsComponent,
    SearchBarComponent,
    ToolbarAlphaComponent,
    ToolbarBetaComponent,
    SearchComponent,
    ToolbarGammaComponent,
    ToolbarNavigationComponent,
    ToolbarNavigationItemComponent,
    ToolbarNavigationDropdownItemComponent
  ],
  entryComponents: [UserDataDialogComponent, DiscordPopupComponent, NameChangeReqComponent, ReportSelfAcceptanceComponent, ConnectorpopupComponent, LoginwindowComponent]
})
export class ToolbarModule { }
